import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "../data/site";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-20 lg:py-32 bg-[#F7F9FC]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <div className="overline mb-4">Frequently Asked</div>
          <h2 className="section-heading text-navy text-3xl md:text-4xl lg:text-5xl font-bold">
            Answers for global buyers.
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white rounded-2xl border border-slate-100 px-6 shadow-sm"
            >
              <AccordionTrigger className="text-left font-semibold text-navy hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
